import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
export const statementStatisticsRouter: RouteRecordRaw[] = [
    {
        path: "WarehouseManagementStatistics",
        name: "WarehouseManagementStatistics",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/WarehouseManagementStatistics/project",
        meta: {
            title: "报表统计"
        },
        children: [
            {
                path: "/WarehouseManagementStatistics/project",
                name: "WarehouseManagementProjectStatement",
                component: () => import("@/views/components/emptyPage/index.vue"),
                meta: {
                    title: "项目报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseManagementStatistics/fund",
                name: "WarehouseManagementFundStatement",
                component: () => import("@/views/components/emptyPage/index.vue"),
                meta: {
                    title: "资金报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseManagementStatistics/customer",
                name: "WarehouseManagementCustomerStatement",
                component: () => import("@/views/components/emptyPage/index.vue"),
                meta: {
                    title: "客户报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseManagementStatistics/stock",
                name: "WarehouseManagementStockStatement",
                meta: {
                    title: "库存报表"
                },
                redirect: "/WarehouseManagementStatistics/stock/detailed",
                children: [
                    {
                        path: "detailed",
                        name: "WarehouseManagementStockDetailed",
                        component: () =>
                            import("@/views/pages/warehouseManagement/statementStatistics/stockStatement/detailed/index.vue"),
                        meta: {
                            title: "库存明细",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_W_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_W_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_W_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "summary",
                        name: "WarehouseManagementStockSummary",
                        component: () =>
                            import("@/views/pages/warehouseManagement/statementStatistics/stockStatement/summary/index.vue"),
                        meta: {
                            title: "库存汇总",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_W_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_W_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_W_PROJECT_DEAL"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
];
